import React from 'react';
import { motion } from 'framer-motion';
const highlights = [{
  role: 'Director of Program Management',
  company: 'Global Tech Solutions',
  period: '2019 - Present',
  initial: 'G',
  logo: '',
  fallbackLogo: '',
  achievements: ['Led a $50M digital transformation initiative across 12 countries.', 'Reduced time-to-market by 30% through agile implementation.', 'Managed a cross-functional team of 45+ senior project managers.']
}, {
  role: 'Senior Program Manager',
  company: 'FinServe International',
  period: '2015 - 2019',
  initial: 'F',
  logo: '',
  fallbackLogo: '',
  achievements: ['Oversaw the integration of two major banking platforms post-merger.', 'Achieved $12M in annual cost savings through process optimization.', 'Implemented enterprise-wide risk management framework.']
}, {
  role: 'Management Consultant',
  company: 'Strategy & Partners',
  period: '2012 - 2015',
  initial: 'S',
  logo: '',
  fallbackLogo: '',
  achievements: ['Advised Fortune 500 clients on operational strategy and execution.', 'Delivered 5 major restructuring projects for manufacturing clients.', 'Recognized as Top Performer for 3 consecutive years.']
}, {
  role: 'Project Lead',
  company: 'Innovate Corp',
  period: '2008 - 2012',
  initial: 'I',
  logo: '',
  fallbackLogo: '',
  achievements: ["Launched the company's flagship mobile application.", 'Coordinated vendor relationships and procurement strategies.', 'Established the internal PMO standards and best practices.']
}];
export function CareerHighlights() {
  return <section className="py-20 bg-corporate-gray" data-id="element-31">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mb-16" data-id="element-33">
          <h2 className="text-2xl md:text-3xl font-bold text-corporate-blue mb-4" data-id="element-34">
            Career Highlights
          </h2>
          <div className="w-20 h-1 bg-corporate-teal rounded-full" data-id="element-35"></div>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-36">
          {highlights.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: index % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-[#FDFBF7] p-6 rounded-lg shadow-sm border-l-4 border-corporate-blue hover:shadow-md transition-shadow" data-id="element-37">
              <div className="flex items-start gap-4 mb-4" data-id="element-38">
                <div className="w-11 h-11 bg-white rounded-xl flex items-center justify-center flex-shrink-0 border border-[#E8E0D0] overflow-hidden p-1.5 mt-0.5" data-id="element-39">
                  {item.logo ? <img src={item.logo} alt={`${item.company} logo`} className="w-full h-full object-contain" onError={e => {
                const target = e.target as HTMLImageElement;
                if (item.fallbackLogo && target.src !== item.fallbackLogo) {
                  target.src = item.fallbackLogo;
                } else {
                  target.style.display = 'none';
                  const parent = target.parentElement;
                  if (parent) {
                    parent.classList.add('bg-corporate-teal/10');
                    parent.innerHTML = `<span class="text-sm font-bold text-corporate-teal">${item.initial}</span>`;
                  }
                }
              }} data-id="element-40" /> : <span className="text-sm font-bold text-corporate-teal" data-id="element-41">
                      {item.initial}
                    </span>}
                </div>
                <div className="flex-1" data-id="element-42">
                  <div className="flex justify-between items-start" data-id="element-43">
                    <div data-id="element-44">
                      <h3 className="text-lg font-bold text-corporate-blue" data-id="element-45">
                        {item.role}
                      </h3>
                      <p className="text-corporate-teal font-medium text-sm" data-id="element-46">
                        {item.company}
                      </p>
                    </div>
                    <span className="text-sm text-[#9A9184] font-medium bg-[#F0EBE1] px-3 py-1 rounded-full flex-shrink-0 ml-2" data-id="element-47">
                      {item.period}
                    </span>
                  </div>
                </div>
              </div>

              <ul className="space-y-3" data-id="element-48">
                {item.achievements.map((achievement, i) => <li key={i} className="flex items-start text-[#6B6356] text-sm" data-id="element-49">
                    <span className="mr-3 mt-1.5 w-1.5 h-1.5 bg-corporate-teal rounded-full flex-shrink-0" data-id="element-50"></span>
                    <span className="leading-relaxed" data-id="element-51">{achievement}</span>
                  </li>)}
              </ul>
            </motion.div>)}
        </div>
      </div>
    </section>;
}